import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { injectIntl } from "react-intl";
import { Alert, Nav, NavItem, Modal, ModalBody, ModalHeader, ModalFooter, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import classnames from "classnames";
import API from "../../api/index";

import StateButton from "Components/StateButton";
import { Row, UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu, FormGroup, Input, Badge, Button, CustomInput, Label } from "reactstrap";
import IntlMessages from "Util/IntlMessages";
import { NotificationManager } from "Components/ReactNotifications";

import PerfectScrollbar from "react-perfect-scrollbar";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { setContainerClassnames, clickOnMobileMenu, logoutUser, changeLocale, addContainerClassname, changeDefaultClassnames, changeSelectedMenuHasSubItems } from "Redux/actions";
import { Colxx } from "Components/CustomBootstrap";
import { menuHiddenBreakpoint, searchPath, localeOptions, showMobileMenu } from "Constants/defaultValues";

import NumberFormat from "react-number-format";
import notifications from "Data/topnav.notifications.json";
import CustomerMobileLookup, { parentCustomerMobileObject } from "Components/CustomerMobileLookup";
function reportNavUrl(path, location) {
    if (!location?.pathname.startsWith('/app/reports/')) return path;
    const old = new URLSearchParams(location.search), next = new URLSearchParams();
    if (['day','week','month'].includes(old.get('type'))) next.set('type', old.get('type'));
    if (/^\d{4}-\d{2}-\d{2}$/.test(old.get('period') || '')) next.set('period', old.get('period'));
    return next.toString() ? `${path}?${next.toString()}` : path;
}
import NumericInput from "react-numeric-input";
class TopNav extends Component {
	constructor(props) {
		super(props);
		this.menuButtonClick = this.menuButtonClick.bind(this);
		this.mobileMenuButtonClick = this.mobileMenuButtonClick.bind(this);
		this.search = this.search.bind(this);
		this.handleChangeLocale = this.handleChangeLocale.bind(this);
		this.handleDocumentClickSearch = this.handleDocumentClickSearch.bind(this);
		this.addEventsSearch = this.addEventsSearch.bind(this);
		this.removeEventsSearch = this.removeEventsSearch.bind(this);
		this.getNotificationByPath = this.getNotificationByPath.bind(this);
		this.toggleModalNewCustomer = this.toggleModalNewCustomer.bind(this);
		this.toggleModalFAQ = this.toggleModalFAQ.bind(this);
		this.toggleModalBankCard = this.toggleModalBankCard.bind(this);
		this.state = {
			notifications: [],
			counter: 0,
			isInFullScreen: false,
			searchKeyword: "",
			selectedParentMenu: "",
			viewingParentMenu: "",
			isOpenModalNewCustomer: false,
			FAQ: [],
			FAQTopTags: [],
			FAQSearchPhrase: "",
			BankCardTransactionAmount: 0,
			BankCardLastTransactionAmount:0,
			BankCardMessage: "",
			isBankCardLoading: false,
			isOpenModalFAQ: false,
			isOpenModalBankCard: false,
			FAQIsLoading: false,
			isFAQDataLoaded: false,
			customerMobile: parentCustomerMobileObject,
			newCustomerName: "",
			newCustomerSurName: "",
			newCustomerType: "",
			newCustomerGender: "",
			newCustomerAgeApproximation: 0,
			newCustomerButtonClicked: false,
			BankCard: null,
		};

		this.customerMobileLookupComponent = React.createRef();

		this.handleCustomerMobileChange = this.handleCustomerMobileChange.bind(this);

		this.handleWindowResize = this.handleWindowResize.bind(this);
		this.addEvents = this.addEvents.bind(this);
		this.removeEvents = this.removeEvents.bind(this);
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.handleProps = this.handleProps.bind(this);
		this.getContainer = this.getContainer.bind(this);
		this.getMenuClassesForResize = this.getMenuClassesForResize.bind(this);
		this.setSelectedLiActive = this.setSelectedLiActive.bind(this);
		this.updateNotificaitons = this.updateNotificaitons.bind(this);
		this.handleNewCustomerReset = this.handleNewCustomerReset.bind(this);
		this.validateNewCustomerCreate = this.validateNewCustomerCreate.bind(this);
		this.handleNewCustomerCreate = this.handleNewCustomerCreate.bind(this);
		this.handleCopyBankCard = this.handleCopyBankCard.bind(this);
	}
	handleCopyToClipboard = (answer, id) => {
		navigator.clipboard.writeText(answer);
		// Set the background to gray for the specific card
		document.getElementById(id).style.backgroundColor = "#ecfcff";
		// Reset the background after 200 milliseconds (adjust timing as needed)
		setTimeout(() => {
			document.getElementById(id).style.backgroundColor = "";
		}, 200);
	};
	handleCopyBankCard = (cardData, id) => {
		const { bank_name, name, surname, card_number, sheba } = cardData;
		const amount = this.state.BankCardLastTransactionAmount;
		// Construct the message
		let message = `
${bank_name}
${name} ${surname}

شماره کارت:
${card_number}

${sheba ? `شماره شبا:\n${sheba}` : ''}

مبلغ:
${new Intl.NumberFormat('fa-IR').format(amount)} تومان
`.trim();
	
		// Copy the message to clipboard
		navigator.clipboard.writeText(message);
	
		// Flash effect on the card
		const cardElement = document.getElementById(id);
		if (cardElement) {
			cardElement.style.opacity = "0.5";
			setTimeout(() => {
				cardElement.style.opacity = "1";
			}, 200);
		}
	};
	validateNewCustomerCreate() {
		if (this.state.customerMobile.isValid && !this.state.customerMobile.isCustomer && this.state.newCustomerType != "" && this.state.newCustomerGender != "") {
			return true;
		}
		return false;
	}
	handleBankCardGet() {
		this.setState({ isBankCardLoading: true });

		API.post("bankcard/get-best", { transactionAmount: this.state.BankCardTransactionAmount }).then((data) => {
			data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
			console.log(data);
			if (data.ERRORS !== undefined && data.ERRORS != null) {
				for (var i = 0; i < data.ERRORS.length; i++) {
					setTimeout(
						function (err) {
							NotificationManager.error(err, "خطا در دریافت کارت بانکی", 8000, null, null, "filled");
						},
						(i + 1) * 700,
						data.ERRORS[i]
					);
					this.setState({
						newCustomerButtonClicked: false,
					});
				}
			} else {
				var message = "کارت بانکی برای مبلغ " + new Intl.NumberFormat("fa-IR").format(this.state.BankCardTransactionAmount) + " تومان";
				this.setState({BankCardLastTransactionAmount:this.state.BankCardTransactionAmount})
				this.setState({ isBankCardLoading: false, BankCard: data.BankCard, BankCardMessage: message, BankCardTransactionAmount: 0 });
				setTimeout(() => {
					this.inputRef.focus(); // Focus on the input
					this.inputRef.select(); // Select the content (0)
				}, 300);
				
			}
		});
	}
	handleNewCustomerCreate() {
		return new Promise((success, fail, $this) => {
			this.setState({ newCustomerButtonClicked: true });
			var tagMap = [];
			tagMap["ASHA"] = 82;
			tagMap["AKSCHAP"] = 83;
			var data = {
				CustomerMobile: this.state.customerMobile.mobile,
				Name: this.state.newCustomerName,
				SurName: this.state.newCustomerSurName,
				Gender: this.state.newCustomerGender,
				HasAddress: false,
				CustomerTagID: tagMap[this.state.newCustomerType],
				OrderInfo: "ثبت مشتری دستگاه",
				AgeApproximation: this.state.newCustomerAgeApproximation,
				Sender: "QUICK_CUSTOMER_MODAL",
			};
			API.post("crm/customer/add", data)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت مشتری");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت مشتری", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								newCustomerButtonClicked: false,
							});
						}
					} else {
						success("مشتری ایجاد شد");
						setTimeout(() => {
							this.setState({ newCustomerButtonClicked: false });
							this.handleNewCustomerReset();
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت مشتری");
				});
		});
	}
	handleCustomerMobileChange(customerMobileObject) {
		this.setState({ customerMobile: customerMobileObject });
	}

	handleChangeLocale = (locale) => {
		this.props.changeLocale(locale);
	};
	isInFullScreen = () => {
		return (
			(document.fullscreenElement && document.fullscreenElement !== null) ||
			(document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
			(document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
			(document.msFullscreenElement && document.msFullscreenElement !== null)
		);
	};
	handleSearchIconClick = (e) => {
		if (window.innerWidth < menuHiddenBreakpoint) {
			let elem = e.target;
			if (!e.target.classList.contains("search")) {
				if (e.target.parentElement.classList.contains("search")) {
					elem = e.target.parentElement;
				} else if (e.target.parentElement.parentElement.classList.contains("search")) {
					elem = e.target.parentElement.parentElement;
				}
			}

			if (elem.classList.contains("mobile-view")) {
				this.search();
				elem.classList.remove("mobile-view");
				this.removeEventsSearch();
			} else {
				elem.classList.add("mobile-view");
				this.addEventsSearch();
			}
		} else {
			this.search();
		}
	};
	addEventsSearch() {
		document.addEventListener("click", this.handleDocumentClickSearch, true);
	}
	removeEventsSearch() {
		document.removeEventListener("click", this.handleDocumentClickSearch, true);
	}

	handleDocumentClickSearch(e) {
		let isSearchClick = false;
		if (e.target && e.target.classList && (e.target.classList.contains("navbar") || e.target.classList.contains("simple-icon-magnifier"))) {
			isSearchClick = true;
			if (e.target.classList.contains("simple-icon-magnifier")) {
				this.search();
			}
		} else if (e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.contains("search")) {
			isSearchClick = true;
		}

		if (!isSearchClick) {
			const input = document.querySelector(".mobile-view");
			if (input && input.classList) input.classList.remove("mobile-view");
			this.removeEventsSearch();
			this.setState({
				searchKeyword: "",
			});
		}
	}
	handleSearchInputChange(e) {
		this.setState({
			searchKeyword: e.target.value,
		});
	}
	handleSearchInputKeyPress(e) {
		if (e.key === "Enter") {
			this.search();
		}
	}

	search() {
		this.props.history.push(searchPath + "/" + this.state.searchKeyword);
		this.setState({
			searchKeyword: "",
		});
	}

	toggleModalNewCustomer() {
		this.setState({
			isOpenModalNewCustomer: !this.state.isOpenModalNewCustomer,
		});
	}
	toggleModalFAQ() {
		this.setState({
			isOpenModalFAQ: !this.state.isOpenModalFAQ,
		});
	}
	toggleModalBankCard = () => {
		this.setState(
			{
				isOpenModalBankCard: !this.state.isOpenModalBankCard,
				BankCardTransactionAmount: 0,
				BankCardLastTransactionAmount:0,
				BankCard: null,
				BankCardMessage:""
			},
			() => {
				// If the modal is open, focus on the input and select its value
				if (this.state.isOpenModalBankCard) {
					this.inputRef.focus(); // Focus on the input
					this.inputRef.select(); // Select the content (0)
				}
			}
		);
	};
	toggleFullScreen = () => {
		const isInFullScreen = this.isInFullScreen();

		var docElm = document.documentElement;
		if (!isInFullScreen) {
			if (docElm.requestFullscreen) {
				docElm.requestFullscreen();
			} else if (docElm.mozRequestFullScreen) {
				docElm.mozRequestFullScreen();
			} else if (docElm.webkitRequestFullScreen) {
				docElm.webkitRequestFullScreen();
			} else if (docElm.msRequestFullscreen) {
				docElm.msRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		}
		this.setState({
			isInFullScreen: !isInFullScreen,
		});
	};

	handleLogout = () => {
		this.props.logoutUser(this.props.history);
	};

	menuButtonClick(e, menuClickCount, containerClassnames) {
		e.preventDefault();

		setTimeout(() => {
			var event = document.createEvent("HTMLEvents");
			event.initEvent("resize", false, false);
			window.dispatchEvent(event);
		}, 350);
		this.props.setContainerClassnames(++menuClickCount, containerClassnames, this.props.selectedMenuHasSubItems);
	}
	mobileMenuButtonClick(e, containerClassnames) {
		e.preventDefault();
		this.props.clickOnMobileMenu(containerClassnames);
	}

	handleWindowResize(event) {
		if (event && !event.isTrusted) {
			return;
		}
		const { containerClassnames } = this.props;
		let nextClasses = this.getMenuClassesForResize(containerClassnames);
		this.props.setContainerClassnames(0, nextClasses.join(" "), this.props.selectedMenuHasSubItems);
	}

	handleDocumentClick(e) {
		const container = this.getContainer();
		let isMenuClick = false;
		if (e.target && e.target.classList && (e.target.classList.contains("menu-button") || e.target.classList.contains("menu-button-mobile"))) {
			isMenuClick = true;
		} else if (e.target.parentElement && e.target.parentElement.classList && (e.target.parentElement.classList.contains("menu-button") || e.target.parentElement.classList.contains("menu-button-mobile"))) {
			isMenuClick = true;
		} else if (
			e.target.parentElement &&
			e.target.parentElement.parentElement &&
			e.target.parentElement.parentElement.classList &&
			(e.target.parentElement.parentElement.classList.contains("menu-button") || e.target.parentElement.parentElement.classList.contains("menu-button-mobile"))
		) {
			isMenuClick = true;
		}
		if (container.contains(e.target) || container === e.target || isMenuClick) {
			return;
		}
		this.toggle(e);
		this.setState({
			viewingParentMenu: "",
		});
	}

	getMenuClassesForResize(classes) {
		const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
		let nextClasses = classes.split(" ").filter((x) => x != "");
		const windowWidth = window.innerWidth;
		if (windowWidth < menuHiddenBreakpoint) {
			nextClasses.push("menu-mobile");
		} else if (windowWidth < subHiddenBreakpoint) {
			nextClasses = nextClasses.filter((x) => x != "menu-mobile");
			if (nextClasses.includes("menu-default") && !nextClasses.includes("menu-sub-hidden")) {
				nextClasses.push("menu-sub-hidden");
			}
		} else {
			nextClasses = nextClasses.filter((x) => x != "menu-mobile");
			if (nextClasses.includes("menu-default") && nextClasses.includes("menu-sub-hidden")) {
				nextClasses = nextClasses.filter((x) => x != "menu-sub-hidden");
			}
		}
		return nextClasses;
	}

	getContainer() {
		return ReactDOM.findDOMNode(this);
	}

	toggle() {
		const { containerClassnames, menuClickCount } = this.props;
		const currentClasses = containerClassnames ? containerClassnames.split(" ").filter((x) => x != "") : "";

		if (currentClasses.includes("menu-sub-hidden") && menuClickCount == 3) {
			this.props.setContainerClassnames(2, containerClassnames, this.props.selectedMenuHasSubItems);
		} else if (currentClasses.includes("menu-hidden") || currentClasses.includes("menu-mobile")) {
			this.props.setContainerClassnames(0, containerClassnames, this.props.selectedMenuHasSubItems);
		}
	}

	handleProps() {
		this.addEvents();
	}

	addEvents() {
		["click", "touchstart"].forEach((event) => document.addEventListener(event, this.handleDocumentClick, true));
	}
	removeEvents() {
		["click", "touchstart"].forEach((event) => document.removeEventListener(event, this.handleDocumentClick, true));
	}
	setSelectedLiActive() {
		const oldli = document.querySelector(".sub-menu  li.active");
		if (oldli != null) {
			oldli.classList.remove("active");
		}

		/* set selected parent menu */
		const selectedlink = document.querySelector(".sub-menu  a.active");
		if (selectedlink != null) {
			selectedlink.parentElement.classList.add("active");
			this.setState({
				selectedParentMenu: selectedlink.parentElement.parentElement.getAttribute("data-parent"),
			});
		} else {
			var selectedParentNoSubItem = document.querySelector(".main-menu  li a.active");
			if (selectedParentNoSubItem != null) {
				this.setState({
					selectedParentMenu: selectedParentNoSubItem.getAttribute("data-flag"),
				});
			} else if (this.state.selectedParentMenu == "") {
				this.setState({
					selectedParentMenu: "dashboards",
				});
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.setSelectedLiActive();
			this.toggle();
			window.scrollTo(0, 0);
		}

		if (
			this.state.isOpenModalFAQ && // Check if isOpenModalFAQ is true
			!prevState.isOpenModalFAQ && // Check if isOpenModalFAQ was false in the previous state
			!this.state.isFAQDataLoaded // Check if data is not previously loaded
		) {
			this.setState({ FAQIsLoading: true, isFAQDataLoaded: true });
			API.post("faq/get", {})
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
					this.setState({
						FAQ: data.faq,
						FAQTopTags: data.topTags,
						FAQIsLoading: false,
					});
				})
				.catch((error) => {});
		}
		if (this._scrollBarRef) {
			this._scrollBarRef._ps.element.scrollTop = this._scrollBarRef._ps.contentHeight;
		}
		this.handleProps();
	}

	componentDidMount() {
		// window.addEventListener("resize", this.handleWindowResize);
		this.handleWindowResize();
		this.handleProps();
		this.setSelectedLiActive();
		this.updateNotificaitons();
		setInterval(this.updateNotificaitons, 5000);
	}

	componentWillUnmount() {
		this.removeEvents();
		// window.removeEventListener("resize", this.handleWindowResize);
	}

	updateNotificaitons() {
		API.system
			.getNotifications()
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					notifications: this.prepareData(data.Notifications),
				});
			})
			.catch((error) => {});
	}
	handleNewCustomerReset() {
		this.setState({ customerMobile: parentCustomerMobileObject, newCustomerName: "", newCustomerSurName: "", newCustomerType: "", newCustomerGender: "", newCustomerAgeApproximation: 0 });
		this.customerMobileLookupComponent.current.reset();
	}
	getNotificationByPath(Path) {
		var Keys = Path.split("/");
		var array = this.state.notifications;
		while (Keys.length > 0) {
			var key = Keys.shift();
			if (array[key] != undefined) {
				array = array[key];
			} else {
				return -1;
			}
		}
		return array;
	}

	prepareData(data) {
		var array = [];
		for (const [key, value] of Object.entries(data)) {
			array[key] = typeof value === "object" ? this.prepareData(value) : value;
		}
		return array;
	}
	openSubMenu(e, selectedParent) {
		e.preventDefault();
		this.props.changeSelectedMenuHasSubItems(true);

		const { containerClassnames, menuClickCount } = this.props;
		const currentClasses = containerClassnames ? containerClassnames.split(" ").filter((x) => x != "") : "";

		if (!currentClasses.includes("menu-mobile")) {
			if (currentClasses.includes("menu-sub-hidden") && (menuClickCount == 2 || menuClickCount == 0)) {
				this.props.setContainerClassnames(3, containerClassnames, true);
			} else if (currentClasses.includes("menu-hidden") && (menuClickCount == 1 || menuClickCount == 3)) {
				this.props.setContainerClassnames(2, containerClassnames, true);
			} else if (currentClasses.includes("menu-default") && !currentClasses.includes("menu-sub-hidden") && (menuClickCount == 1 || menuClickCount == 3)) {
				this.props.setContainerClassnames(0, containerClassnames, true);
			}
		} else {
			this.props.addContainerClassname("sub-show-temporary", containerClassnames);
		}
		this.setState({
			viewingParentMenu: selectedParent,
		});
	}

	changeSelectedParentHasNoSubmenu(e, menu) {
		this.setState({
			viewingParentMenu: menu,
		});
		this.props.changeSelectedMenuHasSubItems(false);
		this.toggle();
	}

	render() {
		const { containerClassnames, menuClickCount, locale } = this.props;
		const { messages } = this.props.intl;
		return (
			<nav className="navbar fixed-top mobile-hide">
				<nav className="navtopbar">
					{showMobileMenu ? (
						<NavLink to="#" className="menu-button d-none d-md-block" onClick={(e) => this.menuButtonClick(e, menuClickCount, containerClassnames)}>
							<svg className="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
								<rect x="0.48" y="0.5" width="7" height="1" />
								<rect x="0.48" y="7.5" width="7" height="1" />
								<rect x="0.48" y="15.5" width="7" height="1" />
							</svg>{" "}
							<svg className="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
								<rect x="1.56" y="0.5" width="16" height="1" />
								<rect x="1.56" y="7.5" width="16" height="1" />
								<rect x="1.56" y="15.5" width="16" height="1" />
							</svg>{" "}
						</NavLink>
					) : (
						false
					)}{" "}
					{showMobileMenu ? (
						<NavLink to="#" className="menu-button-mobile d-xs-block d-sm-block d-md-none" onClick={(e) => this.mobileMenuButtonClick(e, containerClassnames)}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
								<rect x="0.5" y="0.5" width="25" height="1" />
								<rect x="0.5" y="7.5" width="25" height="1" />
								<rect x="0.5" y="15.5" width="25" height="1" />
							</svg>{" "}
						</NavLink>
					) : (
						false
					)}
					<div className="mr-auto">
						<div className="header-icons d-inline-block align-middle">
							<button
								className="smart-akschap header-icon btn btn-empty d-none d-sm-inline-flex"
								type="button"
								aria-label="Smart AksChap :)"
							>
								<svg className="smart-akschap-robot" viewBox="0 0 24 24" aria-hidden="true">
									<path d="M12 3v3M10.5 3h3M6.5 7.5h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2ZM8 12h.01M16 12h.01M8.5 15.5h7M2.5 11v4M21.5 11v4" />
								</svg>
								<span className="smart-akschap-label">Smart AksChap :)</span>
							</button>{" "}
							<button
								className="header-icon btn btn-empty d-none d-sm-inline-block"
								type="button"
								onClick={this.toggleModalBankCard}
								style={{
									fontSize: "1.4rem",
									color: "#4ecdc4",
									fontWeight: "bold",
									borderLeft: "1px dotted rgb(78 205 196 / 46%)",
									borderRadius: "0",
									height: "26px",
									verticalAlign: "top",
									padding: "0",
									paddingTop: "2px",
									paddingLeft: "10px",
									marginTop: "8px",
									marginRight: "2px",
								}}
							>
								<i className="simple-icon-credit-card" />
							</button>{" "}
							<Modal size="lg" isOpen={this.state.isOpenModalBankCard} toggle={this.toggleModalBankCard}>
								<ModalHeader className={"bankcardmodal-header"} toggle={this.toggleModalBankCard}>
									<span style={{ lineHeight: "44px" }}>کارت بانکی برای مبلغ:</span>
									<div style={{ width: 300, float: "left", textAlign: "right", display: "inline", marginRight: "10px", borderRadius: 50 }}>
										<NumberFormat
											value={this.state.BankCardTransactionAmount}
											onClick={this.handleFocus}
											onValueChange={(values) => {
												this.setState({ BankCardTransactionAmount: values.value });
											}}
											onKeyDown={(event) => {
												if (event.key === "Enter") this.handleBankCardGet();
											}}
											getInputRef={(el) => (this.inputRef = el)} // Reference for the input
											style={{
												width: "200px",
												textAlign: "left",
												fontSize: "18px",
												borderRadius: "50px",
												padding: "9px",
												lineHeight: "29px",
												paddingBottom: "5px",
												paddingTop: "7px",
												paddingLeft: "35px",
												paddingRight: "19px",
												border: "1px solid lightgray",
											}}
											thousandSeparator={true}
										/>{" "}
										تومان
									</div>
								</ModalHeader>
								<ModalBody style={{ background: "#d0fbff" }}>
									{this.state.BankCardMessage != "" && (
										<Alert color="success" className="" style={{ textAlign: "center" }}>
											{" "}
											{this.state.BankCardMessage}
										</Alert>
									)}
									{this.state.BankCard != null && (
										<div className="shetabcard"      id="card-1"  onClick={() => this.handleCopyBankCard(this.state.BankCard, "card-1")}>
											<img className="shetablogo" src="https://cust.akschap.com/assets/img/shetablogo.png" />
											<img className="banklogo" src={"https://cust.akschap.com/assets/img/" + this.state.BankCard.bank_name_slug + ".png"} />
											<span className="shetabnumber">{this.state.BankCard.card_number_formatted}</span>
											<span className="shebanumber">{this.state.BankCard.sheba_formatted}</span>
											<span className="shetabname">
												{this.state.BankCard.name} {this.state.BankCard.surname} - {this.state.BankCard.bank_name}
											</span>
										</div>
									)}
								</ModalBody>
								<ModalFooter></ModalFooter>
							</Modal>
							<button
								className="header-icon btn btn-empty d-none d-sm-inline-block"
								type="button"
								onClick={this.toggleModalFAQ}
								style={{
									fontSize: "1.4rem",
									color: "#4ecdc4",
									fontWeight: "bold",
									borderLeft: "1px dotted rgb(78 205 196 / 46%)",
									borderRadius: "0",
									height: "26px",
									verticalAlign: "top",
									padding: "0",
									paddingTop: "2px",
									paddingLeft: "10px",
									marginTop: "8px",
									marginRight: "2px",
								}}
							>
								<i className="simple-icon-question" />
							</button>{" "}
							<Modal size="lg" isOpen={this.state.isOpenModalFAQ} toggle={this.toggleModalFAQ}>
								<ModalHeader className={"faqmodal-header"} toggle={this.toggleModalFAQ}>
									سوالات متداول
									<div style={{ width: 400, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>
										<Input
											autoComplete="off"
											type="text"
											name="FAQSearchPhrase"
											id="FAQSearchPhrase"
											color="info"
											placeholder=""
											value={this.state.FAQSearchPhrase}
											onChange={(e) => {
												this.setState({ FAQSearchPhrase: e.target.value });
											}}
											style={{ borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
										/>
										<Button
											style={{
												position: "absolute",
												top: 22,
												marginRight: "365px",
												marginTop: "11px",
												fontSize: 20,
												padding: "5px",
												color: "lightgray",
												backgroundColor: "transparent",
												border: "unset",
												display: this.state.FAQSearchPhrase != "" ? "block" : "none",
											}}
											onClick={(e) => {
												this.setState({ FAQSearchPhrase: "" });
											}}
										>
											<i className="simple-icon-close"></i>
										</Button>
									</div>
								</ModalHeader>
								<ModalBody style={{ background: "#d0fbff" }}>
									{this.state.FAQSearchPhrase == "" ? (
										<div>
											{Object.keys(this.state.FAQTopTags).map((key) => {
												return (
													<span
														onClick={() => {
															this.setState({ FAQSearchPhrase: key });
														}}
														style={{
															color: "#607D8B",
															border: "1px solid #607D8B",
															padding: "5px",
															paddingLeft: "10px",
															paddingRight: "10px",
															borderRadius: "5px",
															marginLeft: "5px",
															paddingTop: "5px",
															paddingBottom: "1px",
															cursor: "pointer",
															background: "white",
															display: "inline-block",
															marginBottom: "5px",
														}}
														key={key}
													>
														{key} ({this.state.FAQTopTags[key]})
													</span>
												);
											})}
										</div>
									) : (
										<div>
											{this.state.FAQ.filter((row) => {
												return this.state.FAQSearchPhrase.trim() == ""
													? false
													: row.question.indexOf(this.state.FAQSearchPhrase) > -1 || row.tags.indexOf(this.state.FAQSearchPhrase) > -1 || row.answer.indexOf(this.state.FAQSearchPhrase) > -1;
											}).map((item, index) => (
												<Fragment key={index}>
													<Card className="mb-2" style={{ cursor: "pointer" }} id={`flash-card-${index}`} onClick={() => this.handleCopyToClipboard(item.answer, `flash-card-${index}`)}>
														<CardBody style={{ padding: "15px" }}>
															<CardTitle style={{ marginBottom: "10px" }}>
																<div className={"simple-icon-info headingicon"} style={{ fontWeight: "bold" }} />
																{item.question}
															</CardTitle>
															<div style={{ background: "#EBFFED", padding: "15px", borderRadius: "10px", marginBottom: "20px" }}>
																{item.answer.split("\n").map((content, key) => {
																	if (content.trim() == "") {
																		content = "‎";
																	}
																	return (
																		<p style={{ lineHeight: "20px", marginBottom: "0px" }} key={key}>
																			{content}
																		</p>
																	);
																})}
															</div>
															<div>
																{item.tags.split("\n").map((content, key) => {
																	if (content.trim() == "") {
																		content = "‎";
																	}
																	return (
																		<span
																			onClick={() => {
																				this.setState({ FAQSearchPhrase: content });
																			}}
																			style={{
																				color: "#607D8B",
																				border: "1px solid #607D8B",
																				padding: "5px",
																				paddingLeft: "10px",
																				paddingRight: "10px",
																				borderRadius: "5px",
																				marginLeft: "5px",
																				paddingTop: "5px",
																				paddingBottom: "1px",
																				cursor: "pointer",
																			}}
																			key={key}
																		>
																			{content}
																		</span>
																	);
																})}
															</div>
														</CardBody>
													</Card>
													<div className="clearfix" />
												</Fragment>
											))}
										</div>
									)}
								</ModalBody>
								<ModalFooter></ModalFooter>
							</Modal>
							{localStorage.getItem("user_can").split(",").indexOf("manage-crm-customer") > -1 ? (
								<span>
									<button
										className="header-icon btn btn-empty d-none d-sm-inline-block"
										type="button"
										onClick={this.toggleModalNewCustomer}
										style={{
											fontSize: "1.4rem",
											color: "#4ecdc4",
											fontWeight: "bold",
											borderLeft: "1px dotted rgb(78 205 196 / 46%)",
											borderRadius: "0",
											height: "26px",
											verticalAlign: "top",
											padding: "0",
											paddingTop: "2px",
											paddingLeft: "10px",
											marginTop: "8px",
											marginRight: "2px",
										}}
									>
										<i className="simple-icon-user-follow" /> {""}
									</button>{" "}
									<Modal size="lg" isOpen={this.state.isOpenModalNewCustomer} toggle={this.toggleModalNewCustomer}>
										<ModalHeader toggle={this.toggleModalNewCustomer}>ثبت سریع مشتری (دستگاه)</ModalHeader>
										<ModalBody>
											<Row>
												<Colxx sm={4}>
													<CustomerMobileLookup
														isValid={this.state.customerMobile.isValid && !this.state.customerMobile.isCustomer}
														ref={this.customerMobileLookupComponent}
														customerMobileObject={this.state.customerMobile}
														onCustomerMobileChange={this.handleCustomerMobileChange}
													/>
												</Colxx>
												<Colxx sm={4}>
													<FormGroup className={"filter"} style={{ borderRightColor: this.state.newCustomerType == "" ? "#fccdd2" : "#4fcdc4" }}>
														<Label for="newCustomerTypeRadio">نوع مشتری</Label>
														<div>
															<CustomInput
																type="radio"
																id="newCustomerTypeRadio"
																name="newCustomerTypeRadio"
																label="اشا"
																checked={this.state.newCustomerType == "ASHA"}
																onChange={() => {}}
																onClick={(e) => {
																	this.setState({ newCustomerType: "ASHA" });
																}}
															/>
															<CustomInput
																type="radio"
																id="newCustomerTypeRadio2"
																name="newCustomerTypeRadio"
																label="عکسچاپ"
																checked={this.state.newCustomerType == "AKSCHAP"}
																onChange={() => {}}
																onClick={(e) => {
																	this.setState({ newCustomerType: "AKSCHAP" });
																}}
															/>
														</div>
													</FormGroup>
												</Colxx>
												<Colxx sm={4}>
													<FormGroup className={"filter"} style={{ borderRightColor: this.state.newCustomerGender == "" ? "#fccdd2" : "#4fcdc4" }}>
														<Label for="newCustomerGenderRadio">جنسیت</Label>
														<div>
															<CustomInput
																type="radio"
																id="newCustomerGenderRadio"
																name="newCustomerGenderRadio"
																label="خانم"
																checked={this.state.newCustomerGender == "FEMALE"}
																onChange={() => {}}
																onClick={(e) => {
																	this.setState({ newCustomerGender: "FEMALE" });
																}}
															/>
															<CustomInput
																type="radio"
																id="newCustomerGenderRadio2"
																name="newCustomerGenderRadio"
																label="آقا"
																onChange={() => {}}
																checked={this.state.newCustomerGender == "MALE"}
																onClick={(e) => {
																	this.setState({ newCustomerGender: "MALE" });
																}}
															/>
														</div>
													</FormGroup>
												</Colxx>
											</Row>
											<Row>
												<Colxx sm={4}>
													<FormGroup className={"filter "}>
														<Label for="newCustomerName">نام</Label>
														<Input
															type="text"
															name="newCustomerName"
															style={{ width: "100%" }}
															id="newCustomerName"
															onClick={this.handleFocus}
															placeholder=""
															value={this.state.newCustomerName}
															onChange={(e) => {
																this.setState({ newCustomerName: e.target.value });
															}}
														/>
													</FormGroup>
												</Colxx>
												<Colxx sm={4}>
													<FormGroup className={"filter "}>
														<Label for="newCustomerSurName">نام خانوادگی</Label>
														<Input
															type="text"
															name="newCustomerSurName"
															style={{ width: "100%" }}
															id="newCustomerSurName"
															onClick={this.handleFocus}
															placeholder=""
															value={this.state.newCustomerSurName}
															onChange={(e) => {
																this.setState({ newCustomerSurName: e.target.value });
															}}
														/>
													</FormGroup>
												</Colxx>

												<Colxx sm={4}>
													<FormGroup className={"filter"}>
														<Label>سن تقریبی</Label>
														<br />
														<div style={{ marginTop: "10px", marginBottom: "5px" }}>
															<NumericInput
																value={this.state.newCustomerAgeApproximation}
																onChange={(e) => {
																	this.setState({ newCustomerAgeApproximation: e });
																}}
																size={10}
																min={0}
																max={100}
															/>{" "}
															{"ساله"}
														</div>
													</FormGroup>
												</Colxx>
											</Row>
										</ModalBody>
										<ModalFooter>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
													marginTop: "-14px",
												}}
												className={"default"}
												onClick={this.handleNewCustomerReset}
											>
												ریست
											</Button>
											<StateButton disabled={this.newCouponButtonClicked || !this.validateNewCustomerCreate()} id="newCustomerSaveButton" color="primary" className="mb-3 default" onClick={() => this.handleNewCustomerCreate()}>
												ثبت
											</StateButton>
										</ModalFooter>
									</Modal>
								</span>
							) : (
								<span></span>
							)}
							<button className="header-icon btn btn-empty d-none d-sm-inline-block" type="button" id="fullScreenButton" onClick={this.toggleFullScreen}>
								{this.state.isInFullScreen ? <i className="simple-icon-size-actual d-block" /> : <i className="simple-icon-size-fullscreen d-block" />}{" "}
							</button>{" "}
						</div>{" "}
						<span className="name ml-1">
							{" "}
							{localStorage.getItem("user_name")} {localStorage.getItem("user_surname")}{" "}
						</span>{" "}
					</div>{" "}
				</nav>
				<a className="navbar-logo" href="/">
					<span className="logo d-none d-xs-block" />
					<span className="logo-mobile d-block d-xs-none" />
				</a>
				<div className="tabMenusContainer">
					<div className="main-menu">
						<Nav vertical className="list-unstyled">
							{" "}
							{/*
                                  If menu item has no sub items.
                                  Note: If you want use hasn't sub menu item  : Set the menu default type to menu-sub-hidden

                                <NavItem
                                  className={classnames({
                                    active: ((this.state.selectedParentMenu == "dashboards" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "dashboards")
                                  })}
                                >
                                  <NavLink
                                    to="/app/dashboards/default"
                                    onClick={e => this.changeSelectedParentHasNoSubmenu(e, "dashboards")}
                                  >
                                    <i className="iconsminds-shop-4" />{" "}
                                    <IntlMessages id="menu.dashboards" />
                                  </NavLink>
                                </NavItem> */}{" "}
							{}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-order") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "orders" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "orders",
									})}
								>
									<NavLink to="/app/orders/default" onClick={(e) => this.openSubMenu(e, "orders")}>
										<i className="iconsminds-billing" /> سفارش
									</NavLink>
								</NavItem>
							) : (
								false
							)}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-crm") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "crm" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "crm",
									})}
								>
									<NavLink to="/app/crm/default" onClick={(e) => this.openSubMenu(e, "crm")}>
										<i className="iconsminds-male-2" /> مشتریان
									</NavLink>{" "}
								</NavItem>
							) : (
								false
							)}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-sms") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "sms" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "sms",
									})}
								>
									<NavLink to="/app/crm/default" onClick={(e) => this.openSubMenu(e, "sms")}>
										<i className="iconsminds-mail" /> پیامک
									</NavLink>{" "}
								</NavItem>
							) : (
								false
							)}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-accounting") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "accounting" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "accounting",
									})}
								>
									<NavLink to="/app/accounting/default" onClick={(e) => this.openSubMenu(e, "accounting")}>
										<i className="iconsminds-cash-register-2" /> حسابداری
									</NavLink>{" "}
								</NavItem>
							) : (
								false
							)}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-warehousing") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "warehousing" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "warehousing",
									})}
								>
									<NavLink to="/app/warehousing/default" onClick={(e) => this.openSubMenu(e, "warehousing")}>
										<i className="iconsminds-box-close" /> انبارداری
									</NavLink>{" "}
								</NavItem>
							) : (
								false
							)}{" "}
							{localStorage.getItem('user_can').split(",").includes("manage-business-reports") && <NavItem className={classnames({ active: (this.state.selectedParentMenu === 'reports' && !this.state.viewingParentMenu) || this.state.viewingParentMenu === 'reports' })}><NavLink to="/app/reports/overview" onClick={e => this.openSubMenu(e, 'reports')}><i className="iconsminds-pie-chart-3" /> گزارش‌ها</NavLink></NavItem>}
							{/* {localStorage.getItem('user_can').split(",").indexOf("menu-reports") > -1 ?
                                <NavItem
                                  className={classnames({
                                    active: ((this.state.selectedParentMenu == "reports" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "reports")
                                  })}
                                >
                                  <NavLink
                                    to="/app/reports/default"
                                    onClick={e => this.openSubMenu(e, "reports")}
                                  >
                                    <i className="iconsminds-pie-chart-3" />{" "}
                                    گزارشات
                                  </NavLink>
                                </NavItem>
                                : false} */}{" "}
							{/* {localStorage.getItem('user_can').split(",").indexOf("menu-message") > -1 ?
                                <NavItem
                                  className={classnames({
                                    active: ((this.state.selectedParentMenu == "message" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "message")
                                  })}
                                >
                                  <NavLink
                                    to="/app/system/default"
                                    onClick={e => this.openSubMenu(e, "message")}
                                  >
                                    <i className="iconsminds-inbox-full" />{" "}
                                    پیام ها
                                  </NavLink>
                                </NavItem>
                                : false} */}{" "}
							{localStorage.getItem("user_can").split(",").indexOf("menu-system") > -1 ? (
								<NavItem
									className={classnames({
										active: (this.state.selectedParentMenu == "system" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "system",
									})}
								>
									<NavLink to="/app/system/default" onClick={(e) => this.openSubMenu(e, "system")}>
										<i className="iconsminds-gear" /> تنظیمات
										<Badge
											color="danger"
											style={{
												display: this.getNotificationByPath("MENU/SYSTEM/TOTAL") > 0 ? "inline-block" : "none",
											}}
											className="mb-1"
										>
											{" "}
											{this.getNotificationByPath("MENU/SYSTEM/TOTAL")}{" "}
										</Badge>{" "}
									</NavLink>{" "}
								</NavItem>
							) : (
								false
							)}
						</Nav>{" "}
					</div>{" "}
					<div className="sub-menu">
						{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-order") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "orders" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "orders",
								})}
								data-parent="orders"
							>
								<NavItem>
									<NavLink to="/app/orders/new-order">
										<i className="iconsminds-add-file" /> سفارش جدید{" "}
									</NavLink>{" "}
								</NavItem>{" "}
								<NavItem>
									<NavLink to="/app/orders/list-payments">
										<i className="iconsminds-financial" /> صف پرداخت
									</NavLink>{" "}
								</NavItem>{" "}
								<NavItem>
									<NavLink to="/app/orders/list-process">
										<i className="iconsminds-box-close" /> صف پردازش
									</NavLink>{" "}
								</NavItem>{" "}
								<NavItem>
									<NavLink to="/app/orders/archive">
										<i className="iconsminds-data-center" /> آرشیو و جستجو{" "}
									</NavLink>{" "}
								</NavItem>{" "}
								{this.props.location.pathname.indexOf("/app/orders/view-order") === 0 ? (
									<NavItem>
										<NavLink to="/app/orders/view-order">
											<i className="iconsminds-billing" />
											سفارش : {this.props.location.pathname.replace("/app/orders/view-order/", "")}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{this.props.location.pathname.indexOf("/app/customers/view-customer") === 0 ? (
									<NavItem>
										<NavLink to="/app/customers/view-customer">
											<i className="iconsminds-business-man-woman" /> مشتری: {this.props.location.pathname.replace("/app/customers/view-customer/", "")}{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-system") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "system" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "system",
								})}
								data-parent="system"
							>
								{localStorage.getItem("user_can").split(",").indexOf("manage-product-tree") > -1 ? (
									<NavItem>
										<NavLink to="/app/system/product-tree-manager">
											<i className="simple-icon-share" /> درخت دسته بندی محصول{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-product-price") > -1 ? (
									<NavItem>
										<NavLink to="/app/system/product-price-manager">
											<i className="iconsminds-dollar" /> مدیریت قیمت محصول
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-system-log") > -1 ? (
									<NavItem>
										<NavLink to="/app/system/system-log">
											<i className="iconsminds-box-full" /> لاگ سیستم{" "}
											{this.getNotificationByPath("MENU/SYSTEM/SYSTEM-LOG") > 0 ? (
												<Badge
													color="danger"
													style={{
														display: this.getNotificationByPath("MENU/SYSTEM/SYSTEM-LOG") > 0 ? "inline-block" : "none",
													}}
													pill
													className="mb-1"
												>
													{" "}
													{this.getNotificationByPath("MENU/SYSTEM/SYSTEM-LOG")}{" "}
												</Badge>
											) : (
												<span />
											)}{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-crm") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "crm" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "crm",
								})}
								data-parent="crm"
							>
								{localStorage.getItem("user_can").split(",").indexOf("manage-crm-lead") > -1 ? (
									<NavItem>
										<NavLink to="/app/crm/lead">
											<i className="iconsminds-leaning-tower" /> سرنخ ها{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-crm-customer") > -1 ? (
									<NavItem>
										{" "}
										{/* <NavLink to="/app/crm/customer-before-hub"> */}{" "}
										<NavLink to="/app/crm/customer">
											<i className="iconsminds-business-man-woman" /> مشتری ها
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-crm-coupon") > -1 ? (
									<NavItem>
										{" "}
										{/* <NavLink to="/app/crm/customer-before-hub"> */}{" "}
										<NavLink to="/app/crm/coupon/list">
											<i className="iconsminds-pantone" /> کوپن ها
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{this.props.location.pathname.indexOf("/app/crm/coupon/view") === 0 ? (
									<NavItem>
										<NavLink to="/app/crm/coupon/view">
											<i className="iconsminds-project" />
											کوپن : {this.props.location.pathname.replace("/app/crm/coupon/view/", "")}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-sms") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "sms" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "sms",
								})}
								data-parent="sms"
							>
								{localStorage.getItem("user_can").split(",").indexOf("manage-sms") > -1 ? (
									<NavItem>
										<NavLink to="/app/sms/batch">
											<i className="iconsminds-mail-send" />
											ارسال دسته‌ای{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-sms") > -1 ? (
									<NavItem>
										<NavLink to="/app/sms/cronjob">
											<i className="iconsminds-redirect" /> پیام های اتوماتیک
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-sms") > -1 ? (
									<NavItem>
										<NavLink to="/app/sms/trigger">
											<i className="simple-icon-energy" /> پیام های اقدامی
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-accounting") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "accounting" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "accounting",
								})}
								data-parent="accounting"
							>
								{localStorage.getItem("user_can").split(",").indexOf("manage-accounting-journal") > -1 ? (
									<NavItem>
										<NavLink to="/app/accounting/journal">
											<i className="iconsminds-calendar-4" />
											دفتر روزنامه{" "}
										</NavLink>{" "}
									</NavItem>
								) : <div />}
								{localStorage.getItem("user_can").split(",").indexOf("manage-accounting-journal") > -1 ? (
									<NavItem>
										<NavLink to="/app/accounting/product-journal">
											<i className="simple-icon-notebook" /> دفتر محصولات
										</NavLink>
									</NavItem>
								) : <div />}
								{localStorage.getItem("user_can").split(",").indexOf("manage-accounting-journal") > -1 ? (
									<NavItem>
										<NavLink to="/app/accounting/product-report">
											<i className="simple-icon-chart" /> گزارش خرید فروش کالا
										</NavLink>
									</NavItem>
								) : (
									<div />
								)}{" "}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").indexOf("menu-warehousing") > -1 ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "warehousing" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "warehousing",
								})}
								data-parent="warehousing"
							>
								{localStorage.getItem("user_can").split(",").indexOf("manage-warehousing-journal") > -1 ? (
									<NavItem>
										<NavLink to="/app/warehousing/journal">
											<i className="iconsminds-calendar-4" />
											دفتر انبار{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-warehousing-inventory") > -1 ? (
									<NavItem>
										<NavLink to="/app/warehousing/inventory">
											<i className="simple-icon-list" />
											موجودی انبار{" "}
										</NavLink>{" "}
									</NavItem>
								) : (
									<div />
								)}{" "}
								{localStorage.getItem("user_can").split(",").indexOf("manage-warehousing-inventory") > -1 && (
									<NavItem>
										<NavLink to="/app/warehousing/monthly-report">
											<i className="simple-icon-chart" /> گزارش ماهانه
										</NavLink>
									</NavItem>
								)}
							</Nav>
						) : (
							false
						)}{" "}
						{localStorage.getItem("user_can").split(",").includes("manage-business-reports") ? (
							<Nav
								className={classnames({
									"d-block": (this.state.selectedParentMenu == "reports" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "reports",
								})}
								data-parent="reports"
							>
								<NavItem><NavLink to={reportNavUrl('/app/reports/overview',this.props.location)}><i className="simple-icon-chart" /> گزارش سفارش‌ها</NavLink></NavItem>
								<NavItem><NavLink to={reportNavUrl('/app/reports/people',this.props.location)}><i className="simple-icon-people" /> گزارش مخاطبان</NavLink></NavItem>
								{localStorage.getItem('user_can').split(',').includes('manage-operator-reports')&&<NavItem><NavLink to={reportNavUrl('/app/reports/operators',this.props.location)}><i className="simple-icon-user" /> گزارش اپراتورها</NavLink></NavItem>}
							</Nav>
						) : (
							false
						)}
						{/* {localStorage.getItem('user_can').split(",").indexOf("menu-message") > -1 ?
                              <Nav
                                className={classnames({
                                  "d-block": ((this.state.selectedParentMenu == "message" && this.state.viewingParentMenu == "") || this.state.viewingParentMenu == "message")
                                })}
                                data-parent="message"
                              >

                                {localStorage.getItem('user_can').split(",").indexOf("manage-message-system") > -1 ?
                                  <NavItem>
                                    <NavLink to="/app/message/list/system">
                                      <i className="iconsminds-mail-settings" />{" "}
                                      پیام های سیستم
                                    </NavLink>
                                  </NavItem>
                                  : <div />}
                              </Nav>
                              : false} */}{" "}
					</div>{" "}
				</div>{" "}
				<div className="user d-inline-block">
					<UncontrolledDropdown className="dropdown-menu-right">
						<DropdownToggle className="p-0" color="empty">
							<span>
								<img alt="Profile" src={localStorage.getItem("user_image")} />{" "}
							</span>
						</DropdownToggle>{" "}
						<DropdownMenu className="mt-3" right>
							{" "}
							{/* <DropdownItem divider /> */} <DropdownItem onClick={() => this.handleLogout()}>خروج </DropdownItem>{" "}
						</DropdownMenu>{" "}
					</UncontrolledDropdown>{" "}
				</div>
			</nav>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	const { containerClassnames, subHiddenBreakpoint, menuHiddenBreakpoint, menuClickCount, selectedMenuHasSubItems, showMobileMenu } = menu;
	const { locale } = settings;
	return {
		containerClassnames,
		subHiddenBreakpoint,
		menuHiddenBreakpoint,
		menuClickCount,
		selectedMenuHasSubItems,
		showMobileMenu,
		locale,
	};
};
export default injectIntl(
	connect(mapStateToProps, {
		setContainerClassnames,
		addContainerClassname,
		changeDefaultClassnames,
		changeSelectedMenuHasSubItems,
		clickOnMobileMenu,
		logoutUser,
		changeLocale,
		showMobileMenu,
	})(TopNav)
);
